// extracted by mini-css-extract-plugin
export default {"logoWrapper":"nav-pp-logo_logoWrapper__yoN3v","discoBall":"nav-pp-logo_discoBall__Pe6Z0","clubName":"nav-pp-logo_clubName__jJo0S"};